import {
  Calendar,
  CheckCircle,
  Edit,
  Expand,
  Plus,
  Trash,
  Video,
} from "lucide-react";
import { useEffect, useState } from "react";
import { FormReunions } from "./components/FormReunions";
import { useQuery } from "@tanstack/react-query";
import serviceMeetings from "@/services/serviceMeetings";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import "./styles.scss";
import Select from "react-select";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { useLayout } from "@/contexts/UseLayout";
import TemPermissao from "@/components/utils/NiveisDeAcesso";
import { NavLink } from "react-router-dom";
import { IconOverviewVerDesk } from "@/pages/UserGoOn/Overviews/components/IconsOverview";
import { ResumoDesk } from "@/pages/UserGoOn/Desks/ResumoDesk";
import RecurrenceBadge from "./components/RecurrenceBadge";
import { GoogleCalendarConnection } from "./components/GoogleCalendarConnection";
import GoogleOriginBadge from "./components/GoogleOriginBadge";

export function Reunioes() {
  const { t } = useTranslation();
  const context = useLayout();
  const [reuniaoSelecionada, setReuniaoSelecionada] = useState<any>(null);
  const [reuniaoResumo, setReuniaoResumo] = useState<any>(null);
  const [openAddReuniao, setOpenAddReuniao] = useState<any>(null);
  const [payload, setPayload] = useState<any>({});
  const [selectStatus, setSelectStatus] = useState<any>();

  const filtros = [
    {
      label: t("meetingsModule.filters.all"),
      value: "todas",
    },
    {
      label: t("meetingsModule.filters.today"),
      value: "hoje",
    },
    {
      label: t("meetingsModule.filters.tomorrow"),
      value: "amanha",
    },
    {
      label: t("meetingsModule.filters.this_week"),
      value: "semana",
    },
  ];
  const optStatus = [
    {
      label: t("meetingsModule.status.scheduled"),
      value: "marcadas",
    },
    {
      label: t("meetingsModule.status.done"),
      value: "realizadas",
    },
    {
      label: t("meetingsModule.status.reschedule"),
      value: "em remarcacao",
    },
  ];

  const [filtroAtivo, setFiltroAtivo] = useState<any>("todas");

  const { data, isLoading, refetch } = useQuery({
    queryKey: ["reunioes", payload],
    queryFn: async () => {
      const result = await serviceMeetings.getMyMeeting(payload);
      return result ?? [];
    },

    enabled: !!payload,
  });

  useEffect(() => {
    localStorage.setItem(
      "qtd_reunioes",
      JSON.stringify(
        data?.data?.data?.filter((e: any) => e.status === 2).length,
      ),
    );
  }, [data]);

  const reunioes = data?.data?.data;

  async function deleteReuniao(id: any) {
    confirmAlert({
      title: t("common:confirmation"),
      message: t("meetingsModule.confirm.delete"),
      buttons: [
        {
          label: t("common:yes"),
          onClick: async () => {
            try {
              const res = await serviceMeetings.deleteMeeting(id);

              if (res.status === 200) {
                toast.success(t("meetingsModule.messages.delete_success"));
                refetch();
              }
            } catch (error) {
              console.error(error);
            }
          },
        },
        {
          label: t("common:cancel"),
          onClick: () => {},
        },
      ],
    });
  }

  function editCampanha(e: any) {
    setReuniaoSelecionada(e);
    setOpenAddReuniao(true);
  }

  async function checkedReunion(id: any, payload: any) {
    confirmAlert({
      title: t("common:confirmation"),
      message: t("meetingsModule.confirm.change_status"),
      buttons: [
        {
          label: t("common:yes"),
          onClick: async () => {
            try {
              const res = await serviceMeetings.editMeeting(id, payload);

              if (res.status === 200) {
                toast.success(t("meetingsModule.messages.status_success"));
                refetch();
              }
            } catch (error) {
              console.error(error);
            }
          },
        },
        {
          label: t("common:cancel"),
          onClick: () => {},
        },
      ],
    });
  }

  const handleFiltroClick = (value: string) => {
    setFiltroAtivo(value);

    if (value === "hoje" || value === "amanha" || value === "semana") {
      setPayload({ period: value });
    } else if (value === "marcadas") {
      setPayload({ status: 1 });
    } else if (value === "realizadas") {
      setPayload({ status: 2 });
    } else if (value === "em remarcacao") {
      setPayload({ status: 3 });
    } else if (value === "todas") {
      setPayload({});
    }
  };

  function colorStatus(status: any) {
    const colors: any = {
      1: {
        border: "border-[#33FF00]/20",
        text: "text-[#33FF00]",
        bg: "bg-[#33FF00]",
      },
      2: {
        border: "border-[#153DCE]/20",
        text: "text-[#153DCE]",
        bg: "bg-[#153DCE]",
      },
      3: {
        border: "border-[#F0BA0A]/20",
        text: "text-[#F0BA0A]",
        bg: "bg-[#F0BA0A]",
      },
    };
    return colors[Number(status)] || "bg-gray-100 text-gray-600";
  }

  function getMeetingStatus(reuniao: any) {
    if (reuniao?.status == 1) {
      return t("userGoOn:overview.tableDesks.meetingStatus.scheduled");
    }
    if (reuniao?.status == 2) {
      return t("userGoOn:overview.tableDesks.meetingStatus.held");
    }
    if (reuniao?.status == 3) {
      return t("userGoOn:overview.tableDesks.meetingStatus.rescheduling");
    }
    return "-";
  }

  function getMeetingClient(reuniao: any) {
    return (
      reuniao?.cliente?.name ??
      reuniao?.cliente?.name_fantasy ??
      reuniao?.cliente?.nome ??
      reuniao?.cliente?.nome_completo
    );
  }

  function getMeetingAgency(reuniao: any) {
    return reuniao?.agency?.name ?? reuniao?.agency?.name_fantasy;
  }

  return (
    <div className="flex flex-col h-full">
      <div className="flex flex-col">
        <div className="flex items-center gap-2 lg:gap-5">
          <span className="text-base font-medium uppercase">
            {t("meetingsModule.title")}
          </span>
          {TemPermissao(context.userLogged, "reunioes", "criar") && (
            <button
              type="button"
              className="transition-all p-1 rounded-full border border-[#153DCE] hover:scale-105 hover:border-[#153DCE]"
              onClick={() => setOpenAddReuniao(true)}
            >
              <Plus size={15} color="#153DCE" />{" "}
            </button>
          )}
          <NavLink
            to="/reunioesExpansao"
            className="transition-all p-1 rounded-full border border-[#153DCE] hover:scale-105 hover:border-[#153DCE] hidden md:flex"
          >
            <Expand size={15} color="#153DCE" />
          </NavLink>
          <GoogleCalendarConnection compact />
        </div>
        {/* <span className="text-xs -mt-1 text-cinza-300">
          {reunioes?.length ?? 0} reuniões
        </span> */}
      </div>
      {openAddReuniao && (
        <FormReunions
          reuniao={reuniaoSelecionada}
          setReuniao={setReuniaoSelecionada}
          close={setOpenAddReuniao}
          reload={refetch}
        />
      )}
      <div className="flex justify-between flex-wrap gap-1 my-3">
        {filtros?.map((e) => (
          <button
            className={`flex flex-col items-center ${e?.value === filtroAtivo ? "text-black menuNavItemsActive" : "text-black/20 menuNavItems"} hover:text-black text-xs transition-all`}
            type="button"
            onClick={() => {
              handleFiltroClick(e?.value);
              setSelectStatus(null);
            }}
          >
            {e?.label}
            <div className={`borderLabel`}></div>
          </button>
        ))}
      </div>
      <div className="flex justify-center mb-3">
        <div className="w-8/12">
          <Select
            options={optStatus}
            value={selectStatus}
            placeholder={t("meetingsModule.filters.status_placeholder")}
            className="select-custom"
            onChange={(e: any) => {
              handleFiltroClick(e?.value);
              setSelectStatus(e);
            }}
          />
        </div>
      </div>
      <div className="space-y-3 overflow-x-hidden flex-1 overflow-y-auto max-h-[680px]">
        {reunioes?.length === 0 && (
          <span className="text-xs text-cinza-300 text-center block">
            {t("meetingsModule.empty")}
          </span>
        )}
        {isLoading
          ? Array(5)
              .fill(null)
              .map((_, index) => (
                <div
                  className="bg-cinza-100 p-2 rounded-lg animate-pulse"
                  key={index}
                >
                  <div className="flex justify-between items-center">
                    <span className="w-1/2 h-4 bg-gray-300 rounded"></span>
                    <div className="flex gap-2">
                      <span className="w-4 h-4 bg-gray-300 rounded"></span>
                      <span className="w-4 h-4 bg-gray-300 rounded"></span>
                      <span className="w-4 h-4 bg-gray-300 rounded"></span>
                      <span className="w-4 h-4 bg-gray-300 rounded"></span>
                    </div>
                  </div>
                  <div className="text-xs flex gap-2 items-center justify-between mt-1">
                    <span className="w-32 h-4 bg-gray-300 rounded"></span>
                    <span className="w-20 h-4 bg-gray-300 rounded"></span>
                  </div>
                </div>
              ))
          : reunioes?.map((reuniao: any) => (
              <div className="mr-1" key={reuniao.id}>
                <p className="text-[10px] text-[#1E1E1E]/20 pl-4">
                  {format(reuniao?.date, "EEEE, dd 'de' MMM", {
                    locale: ptBR,
                  }).replace(/\b\w/g, (l) => l.toUpperCase())}
                </p>
                <div
                  className={`px-2 py-3 rounded-[14px] border ${colorStatus(reuniao?.status)?.border}`}
                >
                  <div className="flex justify-between">
                    <div className="flex items-center divide-x-2 gap-x-4 w-9/12">
                      <div className="text-[#1E1E1E] flex flex-col items-center">
                        <p className=" text-2xl font-medium leading-5">
                          {format(new Date(reuniao?.date), "dd", {
                            locale: ptBR,
                          })}
                        </p>
                        <p className="text-[10px]">
                          {format(new Date(reuniao?.date), "MMM", {
                            locale: ptBR,
                          })?.replace(/\b\w/g, (l) => l?.toUpperCase())}
                        </p>
                      </div>
                      <div className="pl-4">
                        <p className="text-xs font-medium text-[#1E1E1E]">
                          {reuniao?.title}
                        </p>
                        <div className="mt-1">
                          <RecurrenceBadge meeting={reuniao} />
                          <GoogleOriginBadge meeting={reuniao} />
                        </div>
                        <div className="flex flex-col gap-1 pt-1">
                          {!!reuniao?.cliente && (
                            <div>
                              <p className="text-[8px] text-black/20">
                                Cliente:
                              </p>
                              <p
                                className={`text-xs line-clamp-2 ${colorStatus(reuniao?.status)?.text}`}
                              >
                                {reuniao?.cliente?.name_fantasy ??
                                  reuniao?.cliente?.nome ??
                                  reuniao?.cliente?.nome_completo}
                              </p>
                            </div>
                          )}
                          {!!reuniao?.agency?.name && (
                            <div>
                              <p className="text-[8px] text-black/20">
                                Agência:
                              </p>
                              <p
                                className={`text-xs line-clamp-2 ${colorStatus(reuniao?.status)?.text}`}
                              >
                                {reuniao?.agency?.name}
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-col self-stretch">
                      <div className="flex flex-col items-end justify-between h-full">
                        <div className="flex flex-1">
                          <p
                            className={`text-[10px] ${colorStatus(reuniao?.status)?.text}`}
                          >
                            {moment.utc(reuniao?.date).format("H:mm") + "h"}
                          </p>
                        </div>
                        <div
                          className={`${colorStatus(reuniao?.status)?.bg} w-3 h-3 rounded-full`}
                        ></div>
                      </div>
                    </div>
                  </div>

                  <div className="flex justify-between items-center pt-2">
                    {/* <span className="truncate w-1/2">{reuniao.title}</span> */}
                    <div className="flex gap-2">
                      <button
                        type="button"
                        onClick={() => setReuniaoResumo(reuniao)}
                        title="Visualizar resumo"
                        className="text-cinza-400 hover:text-azul-400 duration-300"
                      >
                        <IconOverviewVerDesk />
                      </button>
                      {reuniao.meet_link && (
                        <a
                          href={reuniao.meet_link}
                          target="_blank"
                          rel="noopener noreferrer"
                          title="Entrar na reunião"
                          className="text-azul-400 hover:opacity-70 transition-opacity"
                        >
                          <Video size={14} strokeWidth={1} />
                        </a>
                      )}
                      {reuniao.calendar_origin !== "google" && TemPermissao(
                        context.userLogged,
                        "reunioes",
                        "editar",
                      ) && (
                        <button
                          type="button"
                          title="Reunião Realizada"
                          onClick={() =>
                            checkedReunion(
                              reuniao.id,
                              reuniao.status == 1
                                ? { status: 2 }
                                : { status: 1 },
                            )
                          }
                          className="hover:text-emerald-500 duration-300"
                        >
                          <CheckCircle size={16} strokeWidth={1} />
                        </button>
                      )}
                      {reuniao.calendar_origin !== "google" && TemPermissao(
                        context.userLogged,
                        "reunioes",
                        "editar",
                      ) && (
                        <button
                          type="button"
                          onClick={() => editCampanha(reuniao)}
                          title="Editar"
                          className="hover:text-azul-400 duration-300"
                        >
                          <Edit size={14} strokeWidth={1} />
                        </button>
                      )}
                      {TemPermissao(
                        context.userLogged,
                        "reunioes",
                        "editar",
                      ) && (
                        <button
                          type="button"
                          title="Remarcar"
                          onClick={() =>
                            checkedReunion(reuniao.id, { status: 3 })
                          }
                          className="hover:text-amber-400 duration-300"
                        >
                          <Calendar size={14} strokeWidth={1} />
                        </button>
                      )}
                      {reuniao.calendar_origin !== "google" && TemPermissao(
                        context.userLogged,
                        "reunioes",
                        "remover",
                      ) && (
                        <button
                          type="button"
                          onClick={() => deleteReuniao(reuniao.id)}
                          title="Deletar"
                          className="hover:text-red-500 duration-300"
                        >
                          <Trash size={14} strokeWidth={1} />
                        </button>
                      )}
                    </div>
                  </div>
                  {/* <div className="text-xs flex gap-2 items-center justify-between mt-1">
                <span
                  className={`text-xs w-fit bg-white px-3 rounded-xl ${(reuniao.status == 1 && "text-emerald-600") ||
                    (reuniao.status == 2 && "text-azul-400") ||
                    (reuniao.status == 3 && "text-amber-400")
                    }`}
                >
                  {reuniao.status == 1 && "Reunião Marcada"}
                  {reuniao.status == 2 && "Reunião Realizada"}
                  {reuniao.status == 3 && "Reunião Em Remarcação"}
                </span>
                <span>
                  {moment.utc(reuniao.date).format("DD/MM/YY - HH:mm")}
                </span>
              </div> */}
                </div>
              </div>
            ))}
      </div>
      {reuniaoResumo && (
        <ResumoDesk
          togleOpen={() => setReuniaoResumo(null)}
          data={reuniaoResumo}
          client={getMeetingClient(reuniaoResumo)}
          status={getMeetingStatus(reuniaoResumo)}
          agency={getMeetingAgency(reuniaoResumo)}
          type="reunion"
          initialTab="timeline"
        />
      )}
    </div>
  );
}
